export const middot = '・';
export const nbspJsString = '\xa0';
export const rouble = '₽';
export const square = '\u00b2';
export const squareMeterShort = `м${square}`;
